<template>
    <div class="app__consents__entries">
        <div v-for="entry in list"
            :key="entry.consentId"
            :ref="entry.consentId"
            class="entry"
        >
            <span :class="['icon', entry.images, {'icon-link' : !entry.images.length}]" />
            <span class="entry__title">{{ entry.title }}</span>
            <span class="icon icon-info"
                @click="toggleEntryDescription(entry.consentId)"
            />
            <span class="entry__description"> {{ entry.description }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'consent-list',
    props: {
        list: {
            type: Array,
            required: true,
        },
    },
    methods: {
        toggleEntryDescription(consentId) {
            this.$refs[consentId][0].classList.toggle('has-visible-description');
        },
    },
};
</script>

<style lang="scss" scoped>
.app__consents__entries {
    .entry {
        padding: 13px 0;
        border-bottom: 1px solid rgba($hit-gray-color, 0.3);

        &:first-child {
            padding-top: 0;
        }

        &__title {
            font-size: 14px;
            display: inline-block;
        }

        .icon {
            font-weight: 700;
            font-size: 18px;
            display: inline-block;
            width: 30px;
            line-height: 20px;
            vertical-align: sub;
        }

        .icon-info {
            float: right;
            color: $blue-comment-text;
            text-align: right;
            cursor: pointer;
        }

        &__description {
            display: block;
            font-size: 13px;
            font-weight: 700;
            color: $lima-color;
            max-height: 0;
            margin: 0;
            overflow-y: hidden;
            transition: 250ms;
        }

        &:last-child {
            border-bottom: none;
            padding-bottom: 0;
        }

        &.has-visible-description {
            .icon-info {
                color: $lima-color;
            }

            .entry__description {
                margin: 5px 0;
                max-height: 100px;
                transition: 500ms;
            }
        }
    }
}
</style>